import { Serializable } from "../core";
import { GeneralCategory, SubCategory } from "./category";
import { Color } from "./color";
import { Category, ProductAttribute } from "./index";

export interface ProductImage {
  id: string;
  url: string;
  index: number;
}

export function isinstanceofProductImage(image: any): boolean {
  if (typeof image !== "object") return false;
  return "id" in image && "url" in image && "index" in image;
}

export class Product implements Serializable<Product> {
  id!: number;
  title!: string;
  description!: string;
  label?: string;
  attributes!: ProductAttribute[];
  images!: ProductImage[];
  generalCategory?: GeneralCategory;
  subCategory?: SubCategory;
  category?: Category;
  colors!: Color[];
  sizes!: string[];
  active!: boolean;

  deserialize(json: any): Product {
    this.id = json.id;
    this.title = json.title;
    this.description = json.description;
    this.label = json.label;
    this.attributes = json.attributes.map((json: any) =>
      new ProductAttribute().deserialize(json)
    );
    this.colors = this.attributes
      .map((attribute) => attribute.color)
      .filter((color, index, self) => self.indexOf(color) === index);
    this.sizes = this.attributes
      .map((attribute) => attribute.size)
      .filter((size, index, self) => self.indexOf(size) === index);
    this.images = json.images
      .sort((a: any, b: any) => {
        if (a.index > b.index) return 1;
        if (a.index < b.index) return -1;
        return 0;
      })
      .map((json: any) => {
        return { id: json.id, url: json.image, index: json.index };
      });
    this.active = json.active;
    if (json.general_category !== null) {
      this.generalCategory = new GeneralCategory().deserialize(
        json.general_category,
        false
      );
      if (json.sub_category !== null) {
        this.subCategory = new SubCategory().deserialize(
          json.sub_category,
          false
        );
        if (json.category !== null)
          this.category = new Category().deserialize(json.category);
      }
    }
    return this;
  }
}
